module.exports = __webpack_public_path__ + "img/logo.dc66f0b3.jpg";